import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import {QR_PREVIEW_DISPLAY_SIZE_PX} from '@Components/qr-code-generator/qr-code-generator.types';
import styles from './qr-preview-panel.module.scss';
import type {QRPreviewPanelProps} from './qr-preview-panel.types';

export function QRPreviewPanel({previewUrl, isRendering, payloadIssueText}: QRPreviewPanelProps): ReactElement {
  const renderPreviewImage = (): ReactElement => {
    if (previewUrl === null) {
      return <div className={styles.qrPreviewPlaceholder} aria-hidden="true" />;
    }
    return (
      <img
        className={styles.qrPreviewImage}
        src={previewUrl}
        alt={window.i18next.t('pmwjs_qr_generator_preview_alt')}
        width={QR_PREVIEW_DISPLAY_SIZE_PX}
        height={QR_PREVIEW_DISPLAY_SIZE_PX}
      />
    );
  };

  const renderPayloadIssue = (): ReactElement | null => {
    if (payloadIssueText === null) {
      return null;
    }
    return <Text val={payloadIssueText} size={TextSize.SM} className={styles.qrPayloadIssue} />;
  };

  return (
    <div className={styles.qrPreviewPanel}>
      <div className={`${styles.qrPreviewFrame} ${isRendering ? styles.qrPreviewFrameRendering : ''}`}>{renderPreviewImage()}</div>
      {renderPayloadIssue()}
    </div>
  );
}
